import { Injectable } from '@angular/core';
import { McticHttpClient } from '@mctic/ng-core';
import { Observable } from 'rxjs';
import { publishReplay, refCount } from 'rxjs/operators';
import { TipoClasse } from './../shared/model/tipo-classe.model';

@Injectable({
  providedIn: 'root'
})
export class TipoClasseService {

  private readonly service = '/sepin-backend/rest/tipo-classe';

  private tipoClasseObservable: Observable<TipoClasse[]>;

  constructor(private readonly http: McticHttpClient) {
  }

  obterTodos() {
    if (!this.tipoClasseObservable) {
      this.tipoClasseObservable = this.http.get<TipoClasse[]>(this.service).pipe(publishReplay(1), refCount());
    }
    return this.tipoClasseObservable;
  }

  obterTipoClassePorProjeto(proprio: boolean) {
    return this.http.get<TipoClasse[]>(`${this.service}/${proprio}/proprio`);
  }
}
